import React from 'react';
import { useNavigate } from 'react-router-dom';
import DemandOne from '../assets/DemandOne.jpg';
import DemandTwo from '../assets/DemandTwo.jpg';
import DemandTree from '../assets/DemandTree.jpg';
import Pedras from '../assets/Pedras.jpeg';
import Caminho from '../assets/Caminho.jpeg';
import Ansiedade from '../assets/Ansiedade.jpeg';
import Frustracao from '../assets/Frustracao.jpeg';
import Procrastinacao from '../assets/Procrastinacao.jpeg';
import Futuro from '../assets/Futuro.jpeg';
import Tempo from '../assets/Tempo.jpeg';
import Amar from '../assets/Amar.jpeg';

const Card = ({ id, title, image, showButton }) => {
  const navigate = useNavigate(); // Hook para navegação

  const handleVerMais = () => {
    // Redireciona para a página correta com base no título do card
    if (title === 'As pedras no caminho') {
      navigate('/pedras');
    } else if (title === 'Tá tudo bem mudar no meio do caminho') {
      navigate('/caminho');
    } else if (title === 'Ansiedade') {
      navigate('/ansiedade');
    } else if (title === 'Frustração') {
      navigate('/frustracao');
    } else if (title === 'Procrastinação') {
      navigate('/procrastinacao');
    } else if (title === 'Futuro') {
      navigate('/futuro');
    }  else if (title === 'Tempo') {
      navigate('/tempo');
    } else if (title === 'Amar') {
      navigate('/amar');
    }
  };

  return (
    <div className="w-full md:w-full mx-auto mb-8 px-2">
      <div className="bg-white p-4 rounded-md shadow-md">
        <img
          src={image}
          alt={`Imagem do Card ${id}`}
          className="w-full h-48 object-cover rounded-md mb-4"
        />
        <h3 className="text-xl font-mukta-mahee text-[#ad6a51] font-bold mb-2 text-center">
          {title.split(' ').map((word, index) => (
            <React.Fragment key={index}>
              {word}
              {index !== title.split(' ').length - 1 && ' '}
            </React.Fragment>
          ))}
        </h3>
        {showButton && (
          <button
            onClick={handleVerMais}
            className="mt-4 w-full bg-[#ad6a51] text-white py-2 px-4 rounded-md hover:bg-[#8a503e] transition"
          >
            Ver mais
          </button>
        )}
      </div>
    </div>
  );
};

const Artigo = () => {
  const cards = [
    { id: 1, title: 'Ansiedade | Autoestima | Medo', image: DemandOne },
    { id: 2, title: 'Humor deprimido | Conflitos interpessoais | Culpa', image: DemandTwo },
    { id: 3, title: 'Procrastinação | Concentração/Foco | Autoconhecimento', image: DemandTree },
    { id: 4, title: 'As pedras no caminho', image: Pedras, showButton: true },
    { id: 5, title: 'Tá tudo bem mudar no meio do caminho', image: Caminho, showButton: true },
    { id: 6, title: 'Ansiedade', image: Ansiedade, showButton: true },
    { id: 7, title: 'Frustração', image: Frustracao, showButton: true },
    { id: 8, title: 'Procrastinação', image: Procrastinacao, showButton: true },
    { id: 9, title: 'Futuro', image: Futuro, showButton: true },
    { id: 10, title: 'Tempo', image: Tempo, showButton: true },
    { id: 11, title: 'Amar', image: Amar, showButton: true },
  ];

  return (
    <section id="Demandas" className="px-3 py-2">
      <h1 className="text-3xl font-bold text-center mb-8 font-mukta-mahee text-[#ad6a51] mt-16">
        Algumas Demandas
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-2 mt-8">
        {cards.map((card) => (
          <Card key={card.id} {...card} />
        ))}
      </div>
    </section>
  );
};

export default Artigo;